import {
    BetRecord,
    betSummarySliceActions,
} from '@/modules/report/slice/betSummary';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import moment from 'moment';
import { CMDSpBetRecordQuery, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDSpBetRecordQueryHandler extends AbstractHandler {
    _command: CMDSpBetRecordQuery;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpBetRecordQuery;
    }

    handle(dispatch: Dispatch<AnyAction>): void {
        const successBetRecords: BetRecord[] = [];
        const unsuccessBetRecords: BetRecord[] = [];

        for (let r of this._command.Bet) {
            const betRecord = {} as BetRecord;
            betRecord.BetAmount = r.BetAmount;
            betRecord.BetID = r.BetID;
            const m = moment.unix(r.BetTime).utc(false);
            betRecord.BetTime =
                m.format('yyyy-MM-DD') + ' ' + m.format('HH:mm:ss');
            betRecord.BetType = r.BetType;
            betRecord.GameID = r.GameID;
            betRecord.Reason = r.Reason;
            betRecord.Remark = r.Remark;
            betRecord.ResultAmount = r.ResultAmount;
            betRecord.RollingAmount = r.RollingAmount;

            if (r.Reason.length > 0) {
                unsuccessBetRecords.push(betRecord);
            } else {
                successBetRecords.push(betRecord);
            }
        }

        dispatch(
            betSummarySliceActions.updateBetRecord({
                successBetRecords: successBetRecords,
                unsuccessBetRecords: unsuccessBetRecords,
            })
        );
    }
}
